import { memo } from 'react';
import ReactTooltip from "react-tooltip";
import ObtRamasArbol from "./ObtRamasArbol";
import DatosNodo from "./DatosNodo";
import icono from './iconos/cifras.png';
import "./Nodos.css"

export default memo(({ id, data, isConnectable }) => {
  let varest=0
  const elems=Object.keys(data);
  elems.map((item) => {if (item === 'cifras') {varest++}});
  return (
    varest>0?
    <div className='inicial'>
      <div style={{ display: 'flex', flexDirection: 'row', flexShrink: 0, justifyContent:'space-between'}}>
        <div className='cajadatos'>{data.label}{data.label2?<br></br>:''}{data.label2}</div>
        <div className='cajacifras' data-tip="msg to show" data-for={id} data-place={data.posmsg}><img src={icono} alt="" className='estiloico' /></div>
        {ObtRamasArbol(id,data.ramas,{isConnectable})}
      </div>
      <ReactTooltip className="extraClass" id={id} type="info" effect="float" backgroundColor='#2e2a2b'>
        {DatosNodo(data.cifras)}
      </ReactTooltip>
    </div >:
    <div style={{ display: 'flex', flexDirection: 'row', flexShrink: 0,justifyContent:'space-between'}}>
      <div className='cajadatos'>{data.label}{data.label2?<br></br>:''}{data.label2}</div>
      {ObtRamasArbol(id,data.ramas,{isConnectable})}
    </div>
  );
});